'use client';

import { PropertyCardFragment } from '@/__generated__/graphql';
import { useFragment } from '@apollo/client';
import React from 'react';
import { BathIcon, BedsIcon } from '../Atoms/Icons';
import { CardBase, CardImage, CardInfo } from '../Cards';
import { PROPERTY_CARD_FRAGMENT } from './Fragments';

interface DemoResultProps {
  id: string;
}

export default function Result({ id }: DemoResultProps) {
  // return null;
  const { data } = useFragment({
    fragment: PROPERTY_CARD_FRAGMENT,
    fragmentName: 'PropertyCard',
    from: { __typename: 'page_Entry', id },
  });
  const [property, setResult] = React.useState<PropertyCardFragment>();

  React.useEffect(() => {
    if (data) setResult(data as PropertyCardFragment);
  }, [data]);

  if (!property)
    return (
      <CardBase>
        <CardImage image={null} />
        <CardInfo title={'...'} description={'...'} linkHref={'#'} />
      </CardBase>
    );

  const { address, featureImage, title, nBathrooms, nBeds, summary, uri } = property;
  const { city, state } = address ?? {};

  return (
    <CardBase>
      <CardImage image={featureImage?.[0]} />
      <CardInfo
        title={title || ''}
        description={summary || ''}
        linkHref={uri || '#'}
        meta={
          <div className="flex items-center gap-2">
            <BedsIcon />
            {nBeds} <BathIcon />
            {nBathrooms}{' '}
            {city && state && (
              <>
                <span>|</span>
                <span className="text-sm">{`${city}, ${state}`}</span>
              </>
            )}
          </div>
        }
      />
    </CardBase>
  );
}
